/**
 * R24 · Mobile Schubladen (Menue/Konto): Oeffnen, Fokus, Burger-Abfang
 *
 * Ausgelagert aus snippets/r24-mobile-drawers.liquid (perf/pdp-weight, 23.09.2026): vorher inline und
 * parserblockierend in jeder Seite, jetzt gecacht und `defer` (laeuft nach dem
 * Parsen, vor DOMContentLoaded). Kein Liquid in dieser Datei.
 */
(function () {
  var root = document.getElementById('r24md');
  if (!root) return;
  var mq = window.matchMedia('(max-width:991px)');   /* = Burger-Grenze des Kopfs (DS-02) */

  /* Icon-Map: Name → Inline-SVG (aus Design-Handoff) */
  var ICONS = {
    kitchen:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="3" width="16" height="18" rx="1.5"/><path d="M4 9h16M8 5.5v1.5M8 13v4"/></svg>',
    planer:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 16.5 16.5 3l4 4L7 20.5z"/><path d="M8 11.5l1.8 1.8M11 8.5l1.8 1.8M14 5.5l1.8 1.8"/></svg>',
    living:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 11V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3"/><path d="M3 11a2 2 0 0 1 2 2v3h14v-3a2 2 0 0 1 2-2"/><path d="M6 19v2M18 19v2"/></svg>',
    bath:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 12h16v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"/><path d="M6 12V6a2 2 0 0 1 2-2h1M8 19l-1 2M17 19l1 2"/></svg>',
    bed:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 18v-6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6M3 14h18M7 10V8a1 1 0 0 1 1-1h3v3M3 18v2M21 18v2"/></svg>',
    dining:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 4v6M4 10c2 0 2-6 0-6M4 10v10M18 4c-2 0-3 2-3 5s1 4 3 4v7"/></svg>',
    baby:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="6" r="2.4"/><path d="M12 9v5M8 11l8 0M9 20l3-3 3 3M5 12a7 7 0 0 0 14 0"/></svg>',
    sale:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20 12l-8 8-9-9V3h8z"/><circle cx="7.5" cy="7.5" r="1.4"/></svg>',
    sparkle:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3l2 5 5 2-5 2-2 5-2-5-5-2 5-2z"/></svg>',
    series:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3l9 5-9 5-9-5 9-5z"/><path d="M3 12l9 5 9-5M3 16.5l9 5 9-5"/></svg>',
    all:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="7" height="7" rx="1.4"/><rect x="14" y="3" width="7" height="7" rx="1.4"/><rect x="3" y="14" width="7" height="7" rx="1.4"/><rect x="14" y="14" width="7" height="7" rx="1.4"/></svg>',
    sets:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="9" width="11" height="11" rx="1.4"/><path d="M8 9V5.4A1.4 1.4 0 0 1 9.4 4h9.2A1.4 1.4 0 0 1 20 5.4v9.2a1.4 1.4 0 0 1-1.4 1.4H14"/></svg>',
    tools:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-7.9 7.9l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9a6 6 0 0 1 7.9-7.9z"/></svg>',
    box:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 7l9-4 9 4-9 4-9-4zM3 7v10l9 4 9-4V7M12 11v10"/></svg>',
    support:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 4h4l2 5-2.4 1.6a12 12 0 0 0 5.8 5.8L15 14l5 2v4a2 2 0 0 1-2.2 2A16 16 0 0 1 2 6.2 2 2 0 0 1 4 4z"/></svg>',
    help:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 0 1 4.5 1.5c0 1.5-2 2-2 3"/><circle cx="12" cy="17" r="0.6" fill="currentColor"/></svg>',
    orders:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/></svg>',
    heart:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 20.5l-1.4-1.3C5.4 14.4 2 11.3 2 7.6 2 4.6 4.3 2.4 7.2 2.4c1.7 0 3.3.8 4.3 2.1 1-1.3 2.6-2.1 4.3-2.1C18.7 2.4 21 4.6 21 7.6c0 3.7-3.4 6.8-8.6 11.6z"/></svg>',
    address:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 21s7-6 7-11a7 7 0 1 0-14 0c0 5 7 11 7 11z"/><circle cx="12" cy="10" r="2.4"/></svg>',
    settings:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"/></svg>',
    profile:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/></svg>',
    info:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><circle cx="12" cy="7.6" r="0.6" fill="currentColor"/></svg>',
    doc:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 2h8l4 4v16H6z"/><path d="M14 2v4h4M9 13h6M9 17h5"/></svg>',
    shield:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3l7 3v5c0 4.4-3 8.3-7 9.5C8 19.3 5 15.4 5 11V6z"/><path d="M9.5 12l1.8 1.8L15 10"/></svg>',
    truck:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M14 17V6H3v11M14 9h4l3 3v5h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>',
    return:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',
    pay:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>'
  };
  /* Nur EIGENE Schlüssel der Karte nachschlagen — sonst liefert z. B. der Schlüssel
     "constructor"/"toString" ein Objekt aus der Prototypenkette statt eines Icons. */
  root.querySelectorAll('[data-r24md-icon]').forEach(function (n) {
    var key = n.getAttribute('data-r24md-icon');
    n.innerHTML = Object.prototype.hasOwnProperty.call(ICONS, key) ? ICONS[key] : ICONS.box;
  });

  /* ENTFERNT (2026-08-21): die Canvas-Logo-Injektion in den m1-Kopf.
     Sie suchte ein Element [data-r24md-logo] — das es in diesem Markup NIE gab (die
     Markenzeile heisst .r24md__logo) — und stieg deshalb bei jedem Seitenaufruf sofort
     wieder aus; ihr beschriebener „Wing-SVG-Fallback" existierte ebenfalls nicht mehr.
     Der Kopf zeigt, wie im Footer entschieden, ausschliesslich die Wortmarke ROYAL24. */

  var hasAccount = !!root.querySelector('.r24md__dw--right .r24md__ahead'); // nur wenn eingeloggt gerendert
  var lastFocus = null, lastOpener = null;

  function lock(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
    document.body.style.overflow = on ? 'hidden' : '';
  }
  function activeDrawer() {
    return root.querySelector(root.classList.contains('side-right') ? '.r24md__dw--right' : '.r24md__dw--left');
  }
  function activePanelEls() {
    /* Fokussierbare Elemente NUR der sichtbaren Schublade — ohne zugeklappte Akkordeon-Inhalte
       ([hidden]); sonst liefe Tab in unsichtbare Links (A15 A2-3). */
    var dw = activeDrawer();
    if (!dw) return [];
    return [].filter.call(dw.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.closest('[hidden]'); });
  }
  /* inert (wo unterstützt) hält alles Unsichtbare aus Tab-Folge UND Screenreader-Baum:
     geschlossener Drawer und die jeweils andere Schublade. */
  function setInert(el, on) {
    if (!el) return;
    if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
  }
  function syncInert() {
    var isOpen = root.classList.contains('is-open');
    var right = root.classList.contains('side-right');
    setInert(root.querySelector('.r24md__dw--left'), !isOpen || right);
    setInert(root.querySelector('.r24md__dw--right'), !isOpen || !right);
  }
  /* Öffner (Burger, Tab „Kategorien", Konto in Kopf/Tab-Leiste) melden ihren Zustand —
     vorher kein aria-expanded; der Burger war ein Link, auf den die Leertaste nicht
     reagierte (A15 A2-4). Nur solange diese Schublade zuständig ist (≤991 px): darüber
     ist das Konto-Symbol ein gewöhnlicher Link und bekommt keine Dialog-Attribute. */
  var OPENERS = '.r24hd-burger,[data-r24-tab="menu"],.r24hd-act--acc,[data-r24-tab="account"]';
  function isAccountOpener(el) { return el.matches('.r24hd-act--acc,[data-r24-tab="account"]'); }
  function syncOpeners() {
    var isOpen = root.classList.contains('is-open');
    var right = root.classList.contains('side-right');
    document.querySelectorAll(OPENERS).forEach(function (el) {
      /* Eingeloggt: „Mein Konto“ öffnet die Konto-Schublade auf ALLEN Breiten (seit 23.09.2026). */
      var deskAccount = hasAccount && isAccountOpener(el);
      if (!mq.matches && !deskAccount) {
        el.removeAttribute('aria-expanded'); el.removeAttribute('aria-controls');
        if (isAccountOpener(el)) el.removeAttribute('aria-haspopup');
        if (el.classList.contains('r24hd-burger')) el.removeAttribute('role');
        return;
      }
      /* Gäste: „Konto" gehört Shopifys Anmeldefenster (r24-account.js) — kein Schubladen-Öffner. */
      if (isAccountOpener(el) && !hasAccount) {
        el.removeAttribute('aria-expanded'); el.removeAttribute('aria-controls'); el.removeAttribute('aria-haspopup');
        return;
      }
      var target = (isAccountOpener(el) && hasAccount) ? 'right' : 'left';
      el.setAttribute('aria-haspopup', 'dialog');
      el.setAttribute('aria-controls', target === 'right' ? 'r24md-right' : 'r24md-left');
      el.setAttribute('aria-expanded', (isOpen && (right ? 'right' : 'left') === target && el === lastOpener) ? 'true' : 'false');
      if (el.classList.contains('r24hd-burger')) el.setAttribute('role', 'button');
    });
  }
  function focusFirst() {
    var els = activePanelEls();
    if (els.length) { try { els[0].focus(); } catch (e) {} }
  }
  function open(side, opener) {
    lastFocus = document.activeElement;
    lastOpener = opener || null;
    root.classList.remove('side-left', 'side-right');
    root.classList.add('is-open', side === 'right' ? 'side-right' : 'side-left');
    root.setAttribute('aria-hidden', 'false');
    syncInert();
    syncOpeners();
    lock(true);
    // Merklisten-Zähler (falls Header einen führt) spiegeln
    if (side === 'right') syncWish();
    setTimeout(focusFirst, 60);
  }
  /* Akkordeon: genau EIN Oberpunkt offen. toggleAcc(btn) öffnet ihn und klappt alle anderen zu;
     ein zweiter Tipp auf denselben schliesst ihn. Der Fokus bleibt auf dem Knopf. */
  function setAcc(btn, on) {
    var p = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (p) p.hidden = !on;
  }
  function closeAccs(except) {
    root.querySelectorAll('[data-r24md-acc][aria-expanded="true"]').forEach(function (b) { if (b !== except) setAcc(b, false); });
  }
  function toggleAcc(btn) {
    var on = btn.getAttribute('aria-expanded') !== 'true';
    closeAccs(btn);
    setAcc(btn, on);
    /* Klappt oberhalb ein langer Oberpunkt zu, rutscht der Knopf nach oben — sichtbar halten. */
    if (on && typeof btn.scrollIntoView === 'function') { try { btn.scrollIntoView({ block: 'nearest' }); } catch (e) {} }
  }
  function close() {
    root.classList.remove('is-open', 'side-left', 'side-right');
    root.setAttribute('aria-hidden', 'true');
    closeAccs(null);
    syncInert();
    syncOpeners();
    lock(false);
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function syncWish() {
    var el = root.querySelector('[data-r24md-wishcount]'); if (!el) return;
    var src = document.querySelector('[data-count-wishlist],.t4s-count-wishlist,[data-wishlist-count],a[href*="wishlist"] .t4s-count-box');
    var n = src ? (src.textContent || '').trim() : '';
    if (n && n !== '0') { el.textContent = n; el.hidden = false; } else { el.hidden = true; }
  }
  function triggerWish() {
    var w = document.querySelector('a[href*="wishlist"],[data-link-wishlist],a[href*="merkzettel"]');
    close();
    if (w) { setTimeout(function () { w.click(); }, 260); }
    /* Findet sich kein Merklisten-Anker (z. B. weil der Kopf noch nicht steht), führte der
       Weg bisher kommentarlos auf die STARTSEITE — eine Sackgasse. Jetzt direkt auf die
       Merklisten-Ansicht, dieselbe Adresse wie im Kopf. */
    else { location.href = '/search?view=wishlist'; }
  }

  /* Delegation innerhalb des Drawers */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-r24md-close]')) { e.preventDefault(); close(); return; }
    var acc = t.closest('[data-r24md-acc]');
    if (acc) { e.preventDefault(); toggleAcc(acc); return; }
    if (t.closest('[data-r24md-wish]')) { e.preventDefault(); triggerWish(); return; }
  });

  /* Esc + Focus-Trap */
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var els = activePanelEls(); if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ── Externe Trigger abfangen (Capture, damit Kalles-Drawer nicht zusätzlich öffnet) ── */
  function wantMenu(el) { return el.closest && el.closest('.r24hd-burger,[data-r24-tab="menu"]'); }
  function wantAccount(el) { return el.closest && el.closest('.r24hd-act--acc,[data-r24-tab="account"]'); }
  document.addEventListener('click', function (e) {
    /* Menü: nur ≤991 px (Burger-Bereich). Konto: nur für Eingeloggte, auf allen Breiten — Konto-Schublade mit
       Bestellungen · Profil · Merkliste · Einstellungen · Abmelden (routes.account_logout_url). Gäste bekommen
       Shopifys Anmeldefenster über r24-account.js; der Klick erreicht die Komponente dann unverändert. */
    var t = e.target, m = mq.matches && wantMenu(t), a = !m && hasAccount && wantAccount(t);
    if (m) { e.preventDefault(); e.stopImmediatePropagation(); open('left', m); return; }
    if (a) {
      e.preventDefault(); e.stopImmediatePropagation();
      open('right', a);
      return;
    }
  }, true);
  /* Burger trägt ≤991 px role="button" → die Leertaste muss ihn auslösen wie einen Knopf
     (Enter löst den Link ohnehin aus). */
  document.addEventListener('keydown', function (e) {
    if (!mq.matches || (e.key !== ' ' && e.key !== 'Spacebar')) return;
    var b = e.target && e.target.closest && e.target.closest('.r24hd-burger');
    if (b) { e.preventDefault(); b.click(); }
  });
  /* Breite wechselt (Drehen, Fenster): Zuständigkeit neu melden; über 991 px darf keine offene MENÜ-Schublade
     zurückbleiben (der Kopf zeigt dort keinen Burger mehr); die Konto-Schublade gilt auf allen Breiten. */
  function onMq() { if (!mq.matches && root.classList.contains('side-left')) close(); syncOpeners(); }
  if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  syncInert();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncOpeners); else syncOpeners();
})();
